<template>
  <div>
    <v-slide-x-transition leave-absolute>
      <router-view></router-view>
    </v-slide-x-transition>
  </div>
</template>

<script>
export default {
  name: 'App',
  data: () => ({
    //
  })
};
</script>
